import * as moment from 'moment';

export const convertYearDayToDate = (year, day) => {
  const date = new Date(year, 0);
  date.setDate(day);
  date.setHours(0);
  date.setMinutes(0);
  return date;
};

export const getVisitBookedForDate = visit => {
  let bookedFor = '-';
  let bookedForDate;
  if (visit.booked_slot) {
    bookedForDate = convertYearDayToDate(visit.booked_slot.year, visit.booked_slot.day);
    bookedFor = `${moment(bookedForDate).format('DD/MM/YYYY')} ${visit.booked_slot.day_of_week} ${visit.booked_slot.slot_begin} - ${visit.booked_slot.slot_end}`;
  }
  return {
    bookedFor,
    bookedForDate,
  };
};

export const getDayOfWeekStringFromDate = date => moment(date).format('dddd');

export const getDateDaysFromToday = noDayFromToday => moment().add(noDayFromToday, 'days').format('YYYY-MM-DD');

export const getDateOfYearDayAndTime = (year, day, slotTime) => {
  const slotDate = convertYearDayToDate(year, day);
  // eslint-disable-next-line radix
  slotDate.setHours(parseInt(slotTime.split(':')[0]));
  // eslint-disable-next-line radix
  slotDate.setMinutes(parseInt(slotTime.split(':')[1]));
  return slotDate;
};

export const getDateTimeOfSlot = bookingSlot => ({
  startDate: getDateOfYearDayAndTime(
    bookingSlot.year,
    bookingSlot.day,
    bookingSlot.slot_begin,
  ),
  endDate: getDateOfYearDayAndTime(
    bookingSlot.year,
    bookingSlot.day,
    bookingSlot.slot_end,
  ),
});
